import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { Avatar, IconButton, Box, Select, MenuItem, FormControl, InputLabel, Typography, TextField } from "@mui/material";
import Switch from "../../components/Switch/Switch";
import NotFound from "../../components/not-found/NotFound";
import Pagination from "react-js-pagination";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { category, concern, music } from "../../routes/route";
import common from "../../routes/common";
import { toastMessage } from "../../utils/toastMessage";
import findSerialNumber from "../../utils/findSerialNumber";
import { charLimit } from "../../utils/charLimit";
import { fetchMusicApi } from "../../services/musicManagement";
import EditIcon from "@mui/icons-material/Edit";
// import AddMusic from "./AddMusicCategory";
import showFullSizeImage from "../../utils/showFullSizeImage";
// import MusicCategoryStatus from "./MusicCategoryStatus";
// import EditMusicCategory from "./EditMusicCategory";
import scrollToUp from "../../utils/scrollToUp";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import ImagePreviewModel from "../../components/imagePreview/ImagePreviewModel";
import AddIcon from "@mui/icons-material/Add";
import { fetchConcernApi } from "../../services/concern/Index";
import { fetchTransactionApi, fetchRechargeHistoryApi, fetchSpendingHistoryApi, fetchRechargeHistorySummaryApi, fetchSpendingHistorySummaryApi, updateTransactionSupportStatusApi, fetchRegisteredAndRechargedSameDayApi } from "../../services/transaction";
import { fatchCategoryApi } from "../../services/categoryManagement";
import { dateFormatWithTime } from "../../utils/dateFormat";
import { CustomTabs, CustomTab } from "../../components/tabs/Tabs";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import RefreshIcon from "@mui/icons-material/Refresh";
import useDownloadWithPassword from "../../hooks/useDownloadWithPassword";
import { SecondaryButton } from "../../components/Button/Button";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
// import AddConcern from "./AddConcern";
// import ConcernStatus from "./ConcernStatus";
// import EditConcern from "./EditConcern";
const { ADD_MUSIC } = category;
const { NOT_FOUND } = common;
const { CONCERN_DETAIL } = concern;

const TransactionManagement = () => {
  // Tab state
  const [activeTab, setActiveTab] = useState(0);
  
  // handle all state
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  
  // Recharge History states
  const [rechargeSearch, setRechargeSearch] = useState(
    getLocalStorage("recharge", "search") || ""
  );
  const [rechargeStatusFilter, setRechargeStatusFilter] = useState("");
  const [rechargeSupportStatusFilter, setRechargeSupportStatusFilter] = useState("");
  const [rechargePlatformFilter, setRechargePlatformFilter] = useState("");
  const [rechargeUserRechargeFilter, setRechargeUserRechargeFilter] = useState("");
  const [rechargeUserTotalRechargesFilter, setRechargeUserTotalRechargesFilter] = useState("");
  const [rechargeList, setRechargeList] = useState([]);
  const [rechargeTotal, setRechargeTotal] = useState(0);
  const [rechargePageSize, setRechargePageSize] = useState(10);
  
  // Spending History states
  const [spendingSearch, setSpendingSearch] = useState(
    getLocalStorage("spending", "search") || ""
  );
  const [spendingSessionTypeFilter, setSpendingSessionTypeFilter] = useState("");
  const [spendingModeFilter, setSpendingModeFilter] = useState("");
  const [spendingProblemFilter, setSpendingProblemFilter] = useState("");
  const [spendingUserSpendFilter, setSpendingUserSpendFilter] = useState("");
  const [spendingUserTotalSpendsFilter, setSpendingUserTotalSpendsFilter] = useState("");
  const [spendingList, setSpendingList] = useState([]);
  const [spendingTotal, setSpendingTotal] = useState(0);
  const [spendingPageSize, setSpendingPageSize] = useState(10);
  
  // Common states
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [addConcernModal, setAddConcernModal] = useState(false);
  const [editConcernModal, setEditConcernModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusId, setStatusId] = useState("");
  const [selectedConcernDetail, setSelectedConcernDetail] = useState(null);
  const [showImagePreviewModel, setShowImagePreviewModel] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [concernTitle, setConcernTitle] = useState("");
  const [rechargeTotalTransaction, setRechargeTotalTransaction] = useState(0);
  const [rechargeTotalAmount, setRechargeTotalAmount] = useState(0);
  const [rechargeSuccessfulCount, setRechargeSuccessfulCount] = useState(0);
  const [rechargeInitiatedStatusCount, setRechargeInitiatedStatusCount] = useState(0);
  const [rechargeUniqueFirstPaymentUsers, setRechargeUniqueFirstPaymentUsers] = useState(0);
  const [rechargeUniqueUsers, setRechargeUniqueUsers] = useState(0);
  const [rechargeAndroidCount, setRechargeAndroidCount] = useState(0);
  const [rechargeIosCount, setRechargeIosCount] = useState(0);
  const [rechargeAndroidSuccessfulCount, setRechargeAndroidSuccessfulCount] = useState(0);
  const [rechargeAndroidInitiatedCount, setRechargeAndroidInitiatedCount] = useState(0);
  const [rechargeAndroidSuccessfulAmount, setRechargeAndroidSuccessfulAmount] = useState(0);
  const [rechargeIosSuccessfulCount, setRechargeIosSuccessfulCount] = useState(0);
  const [rechargeIosInitiatedCount, setRechargeIosInitiatedCount] = useState(0);
  const [rechargeIosSuccessfulAmount, setRechargeIosSuccessfulAmount] = useState(0);
  const [registeredAndRechargedCount, setRegisteredAndRechargedCount] = useState(null);
  const [registeredAndRechargedAmount, setRegisteredAndRechargedAmount] = useState(null);
  const [firstTimeRechargeCount, setFirstTimeRechargeCount] = useState(null);
  const [spendingTotalTransaction, setSpendingTotalTransaction] = useState(0);
  const [spendingTotalAmount, setSpendingTotalAmount] = useState(0);
  
  // Indicator visibility (hidden by default, show on tap)
  const [showRechargeIndicators, setShowRechargeIndicators] = useState(false);
  const [showSpendingIndicators, setShowSpendingIndicators] = useState(false);
  
  // Support status modal states
  const [supportStatusModal, setSupportStatusModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [supportStatus, setSupportStatus] = useState("");
  const [failureType, setFailureType] = useState("");
  const [supportRemarks, setSupportRemarks] = useState("");
  
  // File downloader hook (password required for sheet download)
  const { loading: csvLoading, requestDownload, DownloadPasswordModal } = useDownloadWithPassword();
  
  // Category data states
  const [problemOptions, setProblemOptions] = useState([]);
  const [categoryLoader, setCategoryLoader] = useState(false);

  // Time range filter states
  // Default to today only for fast load
  const [timeRange, setTimeRange] = useState("today");
  const [timeRangeStartDate, setTimeRangeStartDate] = useState("");
  const [timeRangeEndDate, setTimeRangeEndDate] = useState("");
  
  // Debounced search values
  const rechargeDebounceValue = useDebounce(rechargeSearch || "", 300);
  const spendingDebounceValue = useDebounce(spendingSearch || "", 300);
  const formatAmount = (value) => Number(value || 0).toFixed(2);

  // Fetch category data for problem options
  const fetchCategoryData = async () => {
    try {
      setCategoryLoader(true);
      const { data } = await fatchCategoryApi();
      if (data.code === 200) {
        const problemOptionsData =
          data?.result?.categoryList &&
          data?.result?.categoryList.length > 0 &&
          data.result.categoryList.map(({ _id, title }) => ({
            value: title,
            label: title,
          }));
        setProblemOptions(problemOptionsData || []);
      } else {
        setProblemOptions([]);
        toastMessage(data.message, "error", "categoryList");
      }
    } catch (error) {
      console.log("error", error);
      setProblemOptions([]);
    } finally {
      setCategoryLoader(false);
    }
  };

  // Function to set localStorage values whenever the state variables change
  useEffect(() => {
    setLocalStorage("recharge", "search", rechargeSearch);
  }, [rechargeSearch]);
  
  useEffect(() => {
    setLocalStorage("spending", "search", spendingSearch);
  }, [spendingSearch]);

  // Time range options
  const timeRangeOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "last7days", label: "Last 7 Days" },
    { value: "last30days", label: "Last 30 Days" },
    { value: "thisMonth", label: "This Month" },
    { value: "lastMonth", label: "Last Month" },
    { value: "custom", label: "Custom Range" }
  ];

  const userTotalRechargesOptions = Array.from({ length: 20 }, (_, index) => index + 1);
  const userTotalSpendsOptions = Array.from({ length: 20 }, (_, index) => index + 1);

  // Time range handler
  const handleTimeRangeChange = (value) => {
    setTimeRange(value);
    if (value !== 'custom') {
      setTimeRangeStartDate("");
      setTimeRangeEndDate("");
    }
  };

  // Time range date change handler
  const handleTimeRangeDateChange = (type, value) => {
    if (type === 'start') {
      setTimeRangeStartDate(value);
    } else {
      setTimeRangeEndDate(value);
    }
  };

  // Fetch category data on component mount
  useEffect(() => {
    fetchCategoryData();
  }, []);

  //*********Handel status********* */
  const statusUpdateHandler = (id, status) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
  };

  //*********Handle Support Status********* */
  const handleSupportStatusClick = (transaction) => {
    setSelectedTransaction(transaction);
    setSupportStatus(transaction.supportStatus || 'pending');
    setFailureType(transaction.failureType || '');
    setSupportRemarks(transaction.supportRemarks || '');
    setSupportStatusModal(true);
  };

  const handleSupportStatusUpdate = async () => {
    try {
      showLoader();
      const updateData = {
        supportStatus,
        failureType: failureType || null,
        supportRemarks: supportRemarks || null,
        markedBy: getLocalStorage('admin', 'id') // Assuming admin ID is stored in localStorage
      };

      await updateTransactionSupportStatusApi(selectedTransaction._id, updateData);
      toastMessage('Support status updated successfully', 'success', 'supportStatus');
      
      // Refresh the recharge list
      await fetchRechargeList();
      
      // Close modal and reset states
      setSupportStatusModal(false);
      setSelectedTransaction(null);
      setSupportStatus('');
      setFailureType('');
      setSupportRemarks('');
    } catch (error) {
      console.error('Error updating support status:', error);
      toastMessage('Failed to update support status', 'error', 'supportStatus');
    } finally {
      hideLoader();
    }
  };

  // update music category handler
  const updateConcernHandler = (data) => {
    setSelectedConcernDetail(data || null);
    setEditConcernModal(true);
  };

  //*********Handel Block********* */
  // const blockHandler = (id, status) => {
  //     setBlockModal(true);
  //     setBlockId(id);
  //     // setStatusValue(status);
  // };
  //*********Handle update********* */
  // const updateHandler = (id, enName, arName, imageUrl, categoryId) => {
  //   setUpdateModal(true)
  //   setUpdateSubCategoryData({
  //     id,
  //     enName,
  //     arName,
  //     imageUrl,
  //     categoryId,
  //   })
  // }
  // *********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };



  // close model

  const closeModel = () => {
    setSelectedConcernDetail(null);
    setStatusValue("");
    setStatusId("");
    setAddConcernModal(false);
    setStatusModal(false);
    setEditConcernModal(false);
    setImagePreview("");
    setShowImagePreviewModel(false);
    setSupportStatusModal(false);
    setSelectedTransaction(null);
    setSupportStatus("");
    setFailureType("");
    setSupportRemarks("");
  };

  //------------------Recharge History API (list + summary in parallel when no search/filters, like user management)----------------------------------
  const fetchRechargeList = async () => {
    const hasExistingData = rechargeList.length > 0;
    try {
      if (!hasExistingData) showLoader();
      const sendData = {
        page: activePage,
        limit: rechargePageSize
      };
      if (rechargeDebounceValue) sendData.search = rechargeDebounceValue;
      if (rechargeStatusFilter) sendData.statusFilter = rechargeStatusFilter;
      if (rechargeSupportStatusFilter) sendData.supportStatusFilter = rechargeSupportStatusFilter;
      if (rechargePlatformFilter) sendData.platformFilter = rechargePlatformFilter;
      if (rechargeUserRechargeFilter) sendData.userRechargeFilter = rechargeUserRechargeFilter;
      if (rechargeUserTotalRechargesFilter) sendData.userTotalRechargesFilter = rechargeUserTotalRechargesFilter;
      if (timeRange) sendData.timeRange = timeRange;
      if (timeRangeStartDate) sendData.timeRangeStartDate = timeRangeStartDate;
      if (timeRangeEndDate) sendData.timeRangeEndDate = timeRangeEndDate;

      const useFastPath = !rechargeDebounceValue && !rechargeUserRechargeFilter && !rechargeUserTotalRechargesFilter;
      const shouldFetchSummary = showRechargeIndicators;
      if (useFastPath || !shouldFetchSummary) sendData.skipSummary = true;

      const rechargeResponse = await fetchRechargeHistoryApi(sendData);

      const { data } = rechargeResponse;
      if (data.code === 200) {
        setRechargeList(data?.result?.list || []);
        setRechargeTotal(data?.result?.total || 0);
        const res = data?.result || {};
        if (!useFastPath && shouldFetchSummary) {
          setRechargeTotalTransaction(res.totalTransaction ?? 0);
          setRechargeTotalAmount(res.totalAmount ?? 0);
          setRechargeSuccessfulCount(res.totalSuccessfulRechargeCount ?? 0);
          setRechargeInitiatedStatusCount(res.totalUnsuccessfulStatusCount ?? Math.max(0, (res.totalTransaction ?? 0) - (res.totalSuccessfulRechargeCount ?? 0)));
          setRechargeUniqueFirstPaymentUsers(res.uniqueFirstTimeRechargeUsers ?? res.uniqueInitiatedStatus ?? 0);
          setRechargeUniqueUsers(res.uniqueRechargeUsers ?? res.uniqueSuccessfulRechargeUsers ?? 0);
          setRechargeAndroidCount(res.androidRechargeCount ?? 0);
          setRechargeIosCount(res.iosRechargeCount ?? 0);
          setRechargeAndroidSuccessfulCount(res.androidSuccessfulRechargeCount ?? 0);
          setRechargeAndroidInitiatedCount(res.androidUnsuccessfulStatusCount ?? Math.max(0, (res.androidRechargeCount ?? 0) - (res.androidSuccessfulRechargeCount ?? 0)));
          setRechargeAndroidSuccessfulAmount(res.androidSuccessfulAmount ?? 0);
          setRechargeIosSuccessfulCount(res.iosSuccessfulRechargeCount ?? 0);
          setRechargeIosInitiatedCount(res.iosUnsuccessfulStatusCount ?? Math.max(0, (res.iosRechargeCount ?? 0) - (res.iosSuccessfulRechargeCount ?? 0)));
          setRechargeIosSuccessfulAmount(res.iosSuccessfulAmount ?? 0);

          const statsParams = {
            timeRange: timeRange || 'today',
            ...(timeRangeStartDate && { timeRangeStartDate }),
            ...(timeRangeEndDate && { timeRangeEndDate }),
            ...(rechargeDebounceValue && { search: rechargeDebounceValue }),
            ...(rechargeStatusFilter && { statusFilter: rechargeStatusFilter }),
            ...(rechargeSupportStatusFilter && { supportStatusFilter: rechargeSupportStatusFilter }),
            ...(rechargePlatformFilter && { platformFilter: rechargePlatformFilter }),
            ...(rechargeUserRechargeFilter && { userRechargeFilter: rechargeUserRechargeFilter }),
            ...(rechargeUserTotalRechargesFilter && { userTotalRechargesFilter: rechargeUserTotalRechargesFilter })
          };
          fetchRegisteredAndRechargedSameDayApi(statsParams).then((statsResponse) => {
            if (statsResponse?.data?.code === 200) {
              const stats = statsResponse.data.result || {};
              setRegisteredAndRechargedCount(stats.totalUsers ?? 0);
              setRegisteredAndRechargedAmount(stats.totalRechargeAmount ?? 0);
            }
          }).catch(() => {
            setRegisteredAndRechargedCount(0);
            setRegisteredAndRechargedAmount(0);
          });
        }

        if (useFastPath && shouldFetchSummary) {
          const summaryParams = {};
          if (timeRange) summaryParams.timeRange = timeRange;
          if (timeRangeStartDate) summaryParams.timeRangeStartDate = timeRangeStartDate;
          if (timeRangeEndDate) summaryParams.timeRangeEndDate = timeRangeEndDate;
          if (rechargeStatusFilter) summaryParams.statusFilter = rechargeStatusFilter;
          if (rechargeSupportStatusFilter) summaryParams.supportStatusFilter = rechargeSupportStatusFilter;
          if (rechargePlatformFilter) summaryParams.platformFilter = rechargePlatformFilter;

          Promise.allSettled([
            fetchRechargeHistorySummaryApi(summaryParams),
            fetchRegisteredAndRechargedSameDayApi({
              timeRange: timeRange || 'today',
              ...(timeRangeStartDate && { timeRangeStartDate }),
              ...(timeRangeEndDate && { timeRangeEndDate }),
              ...(rechargeStatusFilter && { statusFilter: rechargeStatusFilter }),
              ...(rechargeSupportStatusFilter && { supportStatusFilter: rechargeSupportStatusFilter }),
              ...(rechargePlatformFilter && { platformFilter: rechargePlatformFilter })
            })
          ]).then(([summaryResult, statsResult]) => {
            if (summaryResult.status === 'fulfilled' && summaryResult.value?.data?.code === 200) {
              const r = summaryResult.value.data.result || {};
              setRechargeTotalTransaction(r.totalTransaction ?? 0);
              setRechargeTotalAmount(r.totalAmount ?? 0);
              setRechargeSuccessfulCount(r.totalSuccessfulRechargeCount ?? 0);
              setRechargeInitiatedStatusCount(r.totalUnsuccessfulStatusCount ?? Math.max(0, (r.totalTransaction ?? 0) - (r.totalSuccessfulRechargeCount ?? 0)));
              setRechargeUniqueFirstPaymentUsers(r.uniqueFirstTimeRechargeUsers ?? r.uniqueInitiatedStatus ?? 0);
              setRechargeUniqueUsers(r.uniqueRechargeUsers ?? r.uniqueSuccessfulRechargeUsers ?? 0);
              setRechargeAndroidCount(r.androidRechargeCount ?? 0);
              setRechargeIosCount(r.iosRechargeCount ?? 0);
              setRechargeAndroidSuccessfulCount(r.androidSuccessfulRechargeCount ?? 0);
              setRechargeAndroidInitiatedCount(r.androidUnsuccessfulStatusCount ?? Math.max(0, (r.androidRechargeCount ?? 0) - (r.androidSuccessfulRechargeCount ?? 0)));
              setRechargeAndroidSuccessfulAmount(r.androidSuccessfulAmount ?? 0);
              setRechargeIosSuccessfulCount(r.iosSuccessfulRechargeCount ?? 0);
              setRechargeIosInitiatedCount(r.iosUnsuccessfulStatusCount ?? Math.max(0, (r.iosRechargeCount ?? 0) - (r.iosSuccessfulRechargeCount ?? 0)));
              setRechargeIosSuccessfulAmount(r.iosSuccessfulAmount ?? 0);
            }
            if (statsResult.status === 'fulfilled' && statsResult.value?.data?.code === 200) {
              const statsResultData = statsResult.value.data.result || {};
              setRegisteredAndRechargedCount(statsResultData.totalUsers ?? 0);
              setRegisteredAndRechargedAmount(statsResultData.totalRechargeAmount ?? 0);
              setFirstTimeRechargeCount(statsResultData.firstTimeRechargeUsers ?? null);
            } else {
              setFirstTimeRechargeCount(null);
            }
          });
        }
      } else {
        toastMessage(data.message, "error", "rechargeList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      if (!hasExistingData) hideLoader();
    }
  };

  //------------------Spending History API (list + summary in parallel when no search/filters, like user management)----------------------------------
  const fetchSpendingList = async () => {
    const hasExistingData = spendingList.length > 0;
    try {
      if (!hasExistingData) showLoader();
      const sendData = { page: activePage, limit: spendingPageSize };
      if (spendingDebounceValue) sendData.search = spendingDebounceValue;
      if (spendingSessionTypeFilter) sendData.sessionTypeFilter = spendingSessionTypeFilter;
      if (spendingModeFilter) sendData.modeFilter = spendingModeFilter;
      if (spendingProblemFilter) sendData.problemFilter = spendingProblemFilter;
      if (spendingUserSpendFilter) sendData.userSpendFilter = spendingUserSpendFilter;
      if (spendingUserTotalSpendsFilter) sendData.userTotalSpendsFilter = spendingUserTotalSpendsFilter;
      if (timeRange) sendData.timeRange = timeRange;
      if (timeRangeStartDate) sendData.timeRangeStartDate = timeRangeStartDate;
      if (timeRangeEndDate) sendData.timeRangeEndDate = timeRangeEndDate;

      const useFastPath = !spendingDebounceValue && !spendingUserSpendFilter && !spendingUserTotalSpendsFilter;
      const shouldFetchSummary = showSpendingIndicators;
      if (useFastPath || !shouldFetchSummary) sendData.skipSummary = true;

      const spendingResponse = await fetchSpendingHistoryApi(sendData);
      const { data } = spendingResponse;

      if (data.code === 200) {
        setSpendingList(data?.result?.list || []);
        setSpendingTotal(data?.result?.total || 0);
        if (!useFastPath && shouldFetchSummary) {
          setSpendingTotalTransaction(data?.result?.totalTransaction ?? 0);
          setSpendingTotalAmount(data?.result?.totalAmount ?? 0);
        }
        if (useFastPath && shouldFetchSummary) {
          const summaryParams = {};
          if (timeRange) summaryParams.timeRange = timeRange;
          if (timeRangeStartDate) summaryParams.timeRangeStartDate = timeRangeStartDate;
          if (timeRangeEndDate) summaryParams.timeRangeEndDate = timeRangeEndDate;
          fetchSpendingHistorySummaryApi(summaryParams).then((summaryResponse) => {
            if (summaryResponse?.data?.code === 200) {
              setSpendingTotalTransaction(summaryResponse.data.result?.totalTransaction ?? 0);
              setSpendingTotalAmount(summaryResponse.data.result?.totalAmount ?? 0);
            }
          }).catch((error) => console.log("error", error));
        }
      } else {
        toastMessage(data.message, "error", "spendingList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      if (!hasExistingData) hideLoader();
    }
  };

  // useEffect for Recharge History
  useEffect(() => {
    if (activeTab === 0) {
      fetchRechargeList();
    }
  }, [
    activePage,
    rechargeDebounceValue,
    rechargeStatusFilter,
    rechargeSupportStatusFilter,
    rechargePlatformFilter,
    rechargeUserRechargeFilter,
    rechargeUserTotalRechargesFilter,
    rechargePageSize,
    activeTab,
    timeRange,
    timeRangeStartDate,
    timeRangeEndDate,
    showRechargeIndicators
  ]);

  // useEffect for Spending History
  useEffect(() => {
    if (activeTab === 1) {
      fetchSpendingList();
    }
  }, [activePage, spendingDebounceValue, spendingSessionTypeFilter, spendingModeFilter, spendingProblemFilter, spendingUserSpendFilter, spendingUserTotalSpendsFilter, spendingPageSize, activeTab, timeRange, timeRangeStartDate, timeRangeEndDate, showSpendingIndicators]);

  // Tab change handler
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    // Reset page to 1 when switching tabs
    searchParam.set("page", 1)
    setSearchParam(searchParam);
  };

  // Filter handlers
  const clearRechargeFilters = () => {
    setRechargeSearch("");
    setRechargeStatusFilter("");
    setRechargeSupportStatusFilter("");
    setRechargePlatformFilter("");
    setRechargeUserRechargeFilter("");
    setRechargeUserTotalRechargesFilter("");
    setTimeRange("");
    setTimeRangeStartDate("");
    setTimeRangeEndDate("");
    setRegisteredAndRechargedCount(null);
    setRegisteredAndRechargedAmount(null);
    searchParam.set("page", 1)
    setSearchParam(searchParam);
  };

  const clearSpendingFilters = () => {
    setSpendingSearch("");
    setSpendingSessionTypeFilter("");
    setSpendingModeFilter("");
    setSpendingProblemFilter("");
    setSpendingUserSpendFilter("");
    setSpendingUserTotalSpendsFilter("");
    setTimeRange("");
    setTimeRangeStartDate("");
    setTimeRangeEndDate("");
    searchParam.set("page", 1)

    setSearchParam(searchParam);
  };

  // CSV Download handlers (password required before download)
  const downloadRechargeCSV = () => {
    try {
      const currentDate = new Date().toISOString().slice(0, 10);
      const fileName = `recharge-history-${currentDate}.csv`;
      const params = {
        export: 'csv',
        ...(rechargeDebounceValue && { search: rechargeDebounceValue }),
        ...(rechargeStatusFilter && { statusFilter: rechargeStatusFilter }),
        ...(rechargeSupportStatusFilter && { supportStatusFilter: rechargeSupportStatusFilter }),
        ...(rechargePlatformFilter && { platformFilter: rechargePlatformFilter }),
        ...(rechargeUserRechargeFilter && { userRechargeFilter: rechargeUserRechargeFilter }),
        ...(rechargeUserTotalRechargesFilter && { userTotalRechargesFilter: rechargeUserTotalRechargesFilter }),
        ...(timeRange && { timeRange: timeRange }),
        ...(timeRangeStartDate && { timeRangeStartDate: timeRangeStartDate }),
        ...(timeRangeEndDate && { timeRangeEndDate: timeRangeEndDate })
      };
      requestDownload('/admin/transaction/recharge-history/export', fileName, params);
    } catch (error) {
      console.error('Error downloading recharge CSV:', error);
      toastMessage('Failed to download CSV file', 'error', 'csvDownload');
    }
  };

  const downloadSpendingCSV = () => {
    try {
      const currentDate = new Date().toISOString().slice(0, 10);
      const fileName = `spending-history-${currentDate}.csv`;
      const params = {
        export: 'csv',
        ...(spendingDebounceValue && { search: spendingDebounceValue }),
        ...(spendingSessionTypeFilter && { sessionTypeFilter: spendingSessionTypeFilter }),
        ...(spendingModeFilter && { modeFilter: spendingModeFilter }),
        ...(spendingProblemFilter && { problemFilter: spendingProblemFilter }),
        ...(spendingUserSpendFilter && { userSpendFilter: spendingUserSpendFilter }),
        ...(spendingUserTotalSpendsFilter && { userTotalSpendsFilter: spendingUserTotalSpendsFilter }),
        ...(timeRange && { timeRange: timeRange }),
        ...(timeRangeStartDate && { timeRangeStartDate: timeRangeStartDate }),
        ...(timeRangeEndDate && { timeRangeEndDate: timeRangeEndDate })
      };
      requestDownload('/admin/transaction/spending-history/export', fileName, params);
    } catch (error) {
      console.error('Error downloading spending CSV:', error);
      toastMessage('Failed to download CSV file', 'error', 'csvDownload');
    }
  };

  // Calculate totals for indicators
  const getRechargeIndicators = () => {
    const successfulTransactions = rechargeList.filter(item => item.status === 'successful');
    const totalAmount = successfulTransactions.reduce((sum, item) => sum + (item.amount || 0), 0);
    return {
      totalTransactions: successfulTransactions.length,
      totalAmount: totalAmount
    };
  };

  const getSpendingIndicators = () => {
    const successfulTransactions = spendingList.filter(item => item.status === 'successful');
    const totalCoins = successfulTransactions.reduce((sum, item) => sum + (item.coinsSpent || 0), 0);
    return {
      totalTransactions: successfulTransactions.length,
      totalCoins: totalCoins
    };
  };
  

  const formatDuration = (seconds) => {
    if (!seconds) return "0 min 0 sec"
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = Math.floor(seconds % 60)
    return `${minutes} min ${remainingSeconds} sec`
  };





  return (
    <>
      <DownloadPasswordModal />
      {loader}
      <div className="WrapperArea transaction-page">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Transaction Management</h4>
          </div>

          {/* Tab Navigation */}
          <Box sx={{ width: '100%', marginBottom: '20px' }}>
            <CustomTabs
              value={activeTab}
              onChange={handleTabChange}
              aria-label="transaction tabs"
            >
              <CustomTab label="Recharge History" />
              <CustomTab label="Spending History" />
            </CustomTabs>
          </Box>

          {/* Recharge History Tab */}
          {activeTab === 0 && (
            <>
              {/* Indicator Tabs - hidden by default, show on tap */}
              <div className="indicator-tabs" style={{ marginBottom: '20px' }}>
                {!showRechargeIndicators ? (
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={() => setShowRechargeIndicators(true)}
                    onKeyDown={(e) => e.key === 'Enter' && setShowRechargeIndicators(true)}
                    style={{
                      padding: '10px 16px',
                      background: '#f0f0f0',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: '#666',
                      userSelect: 'none'
                    }}
                  >
                    Tap to show recharge summary
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {rechargeTotalTransaction}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Total initiated (all attempts)</div>
                    </div>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        Rs.{formatAmount(rechargeTotalAmount)}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Total recharge amount (successful Rs.)</div>
                    </div>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {rechargeSuccessfulCount}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Successful recharges (count)</div>
                    </div>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {rechargeAndroidCount}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Android total attempts</div>
                    </div>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {rechargeAndroidSuccessfulCount}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Android successful</div>
                    </div>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {rechargeAndroidInitiatedCount}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Android failures/initiated</div>
                    </div>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        Rs.{formatAmount(rechargeAndroidSuccessfulAmount)}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Android successful amount</div>
                    </div>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {rechargeIosCount}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>iOS total attempts</div>
                    </div>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {rechargeIosSuccessfulCount}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>iOS successful</div>
                    </div>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {rechargeIosInitiatedCount}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>iOS failures/initiated</div>
                    </div>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        Rs.{formatAmount(rechargeIosSuccessfulAmount)}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>iOS successful amount</div>
                    </div>
                    <div
                      className="indicator-item"
                      title="Jin filters ke saath total attempts dikhte hain (jaise 101), unme kitne alag users hain — har user ek baar. Status filter laga ho to usi hisaab se (sirf successful / fail / initiated)."
                      style={{
                        background: '#f0f0f0',
                        padding: '10px 20px',
                        borderRadius: '8px',
                        textAlign: 'center',
                        maxWidth: '240px'
                      }}
                    >
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {rechargeUniqueUsers}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Total users </div>
                    </div>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {rechargeInitiatedStatusCount}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Failure/initiated orders</div>
                    </div>
                    <div
                      className="indicator-item"
                      title="Un unique users ki ginti jinhone is date range mein pehli baar payment try ki (success / fail / initiated — koi bhi). Ek user ne 3 orders kiye to bhi count 1."
                      style={{ 
                        background: '#f0f0f0', 
                        padding: '10px 20px', 
                        borderRadius: '8px',
                        textAlign: 'center',
                        maxWidth: '240px'
                      }}
                    >
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {rechargeUniqueFirstPaymentUsers}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Unique users </div>
                    </div>
                    <div
                      className="indicator-item"
                      title="Selected date range mein register hue aur usi date range mein successful recharge karne wale unique users."
                      style={{
                        background: '#fff3e0',
                        padding: '10px 20px',
                        borderRadius: '8px',
                        textAlign: 'center'
                      }}
                    >
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {registeredAndRechargedCount ?? 0}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Registered &amp; recharged users</div>
                    </div>
                    <div
                      className="indicator-item"
                      title="In same-day registered users ke selected date range ke sabhi successful recharge ka total amount."
                      style={{
                        background: '#fff3e0',
                        padding: '10px 20px',
                        borderRadius: '8px',
                        textAlign: 'center'
                      }}
                    >
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        Rs.{formatAmount(registeredAndRechargedAmount)}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Registered &amp; recharged amount</div>
                    </div>
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => setShowRechargeIndicators(false)}
                      onKeyDown={(e) => e.key === 'Enter' && setShowRechargeIndicators(false)}
                      style={{
                        padding: '10px 16px',
                        alignSelf: 'center',
                        cursor: 'pointer',
                        fontSize: '12px',
                        color: '#666',
                        textDecoration: 'underline',
                        userSelect: 'none'
                      }}
                    >
                      Hide summary
                    </div>
                  </div>
                )}
              </div>

              {/* Filters */}
              <div className="FilterBox FilterArea" style={{ flexDirection: 'column' }}>
                {/* Row 1: Search Bar and Basic Filters */}
                <div className="group_filter_value" style={{ 
                  marginBottom: '15px', 
                  display: 'flex !important', 
                  flexWrap: 'wrap !important', 
                  gap: '15px', 
                  alignItems: 'center',
                  width: '100%',
                  flexDirection: 'row'
                }}>
                  {/* Search Bar */}
                  <div className="form-group search_md_size userSearch" style={{ minWidth: '200px', flex: '1 1 auto' }}>
              <input
                type="search"
                      className={`form-control ${rechargeSearch && "active"}`}
                      placeholder="Search by User Name, User ID"
                      value={rechargeSearch || ""}
                style={{ "--color": "#FF8989" }}
                      onChange={(e) => setRechargeSearch(e.target.value)}
                    />
                  </div>

                  {/* Time Range Filter */}
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>Time Range</InputLabel>
                      <Select
                        value={timeRange}
                        onChange={(e) => handleTimeRangeChange(e.target.value)}
                        label="Time Range"
                      >
                        <MenuItem value="">
                          <em>All Time Ranges</em>
                        </MenuItem>
                        {timeRangeOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  
                  {timeRange === 'custom' && (
                    <>
                      <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                        <TextField
                          size="small"
                          type="date"
                          variant="outlined"
                          label="Start Date"
                          value={timeRangeStartDate}
                          onChange={(e) => handleTimeRangeDateChange('start', e.target.value)}
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                      <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                        <TextField
                          size="small"
                          type="date"
                          variant="outlined"
                          label="End Date"
                          value={timeRangeEndDate}
                          onChange={(e) => handleTimeRangeDateChange('end', e.target.value)}
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                    </>
                  )}

                  {/* Status */}
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={rechargeStatusFilter}
                        onChange={(e) => setRechargeStatusFilter(e.target.value)}
                        label="Status"
                      >
                        <MenuItem value="">
                          <em>All Status</em>
                        </MenuItem>
                        <MenuItem value="successful">Successful</MenuItem>
                        <MenuItem value="failed">Failed</MenuItem>
                        <MenuItem value="initiated">Intiated</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  {/* Support Status */}
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>Support Status</InputLabel>
                      <Select
                        value={rechargeSupportStatusFilter}
                        onChange={(e) => setRechargeSupportStatusFilter(e.target.value)}
                        label="Support Status"
                      >
                        <MenuItem value="">
                          <em>All Support Status</em>
                        </MenuItem>
                        <MenuItem value="pending">Pending</MenuItem>
                        <MenuItem value="marked">Marked</MenuItem>
                        <MenuItem value="resolved">Resolved</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  {/* Platform Filter */}
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>Platform</InputLabel>
                      <Select
                        value={rechargePlatformFilter}
                        onChange={(e) => setRechargePlatformFilter(e.target.value)}
                        label="Platform"
                      >
                        <MenuItem value="">
                          <em>All Platforms</em>
                        </MenuItem>
                        <MenuItem value="android">Android</MenuItem>
                        <MenuItem value="ios">iOS</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  {/* User Recharge # Filter */}
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>User Recharge #</InputLabel>
                      <Select
                        value={rechargeUserRechargeFilter}
                        onChange={(e) => setRechargeUserRechargeFilter(e.target.value)}
                        label="User Recharge #"
                      >
                        <MenuItem value="">
                          <em>All User Recharges</em>
                        </MenuItem>
                        <MenuItem value="1">1</MenuItem>
                        <MenuItem value="2">2</MenuItem>
                        <MenuItem value="3">3</MenuItem>
                        <MenuItem value="repeat">Repeat</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  {/* User Total Recharges Filter */}
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>User Total Recharges</InputLabel>
                      <Select
                        value={rechargeUserTotalRechargesFilter}
                        onChange={(e) => setRechargeUserTotalRechargesFilter(e.target.value)}
                        label="User Total Recharges"
                      >
                        <MenuItem value="">
                          <em>All Totals</em>
                        </MenuItem>
                        {userTotalRechargesOptions.map((value) => (
                          <MenuItem key={value} value={String(value)}>
                            {value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  {/* Apply Filter & Clear */}
                  <div className="form-group refresh_button" style={{ minWidth: '120px', flex: '0 0 auto', display: 'flex', gap: '10px' }}>
                    <SecondaryButton onClick={() => fetchRechargeList()}>
                      Apply
                    </SecondaryButton>
                    <SecondaryButton onClick={clearRechargeFilters}>
                      Clear
                    </SecondaryButton>
                    <SecondaryButton 
                      onClick={downloadRechargeCSV}
                      disabled={csvLoading}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '8px 16px',
                        fontSize: '14px',
                        fontWeight: '500'
                      }}
                    >
                      {csvLoading ? (
                        <span>Downloading...</span>
                      ) : (
                        <>
                          <FileDownloadIcon style={{ fontSize: '16px' }} />
                          Export CSV
                        </>
                      )}
                    </SecondaryButton>
                  </div>
            
                 
            </div>
          </div>

              {/* Recharge History Table */}
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Order Id</th>
                  <th>Date & Time</th>
                      <th>User ID</th>
                  <th>User Name</th>
                  <th>User Recharge </th>
                  <th>User Total Recharges</th>
                      <th>Recharge Amt (₹)</th>
                      
                      <th>Recharge Status</th>
                      <th>Coin Received</th>
                      <th>Platform</th>
                      <th>Payment Gateway</th>
                      <th>Support Status</th>
                      <th>Remarks</th>
                      <th>Action</th>
                </tr>
              </thead>
              <tbody>
                    {rechargeList.length > 0 ? (
                      rechargeList.map((transaction, index) => (
                      <React.Fragment key={transaction._id || "---"}>
                        <tr>
                            <td>{findSerialNumber(index, activePage, rechargePageSize) || "---"}</td>
                            <td>
                              
                             {transaction?.orderId || "---"}</td>
                            <td>{dateFormatWithTime(transaction?.createdAt) || "---"}</td>

                            <td><Link to={`/user/user-detail/${transaction?.userDetails?._id}`} target="_blank">{transaction?.userDetails?.userId || "---"}</Link></td>
                          <td>
                              <Link to={`/user/user-detail/${transaction?.userDetails?._id}`} target="_blank" style={{ textDecoration: 'none' }}>
                                {charLimit(transaction?.userDetails?.name, 30) || "---"}
                              </Link>
                          </td>
                            <td title={transaction?.userRechargeNumber != null ? `This is this user's ${transaction.userRechargeNumber} recharge (total ${transaction?.userTotalRecharges ?? '—'} recharges)` : undefined}>
                              {transaction?.userRechargeNumber != null ? (() => {
                                const n = Number(transaction.userRechargeNumber);
                                if (Number.isNaN(n)) return '-----';
                                if (n > 3) return 'Repeat';
                                const s = ['th', 'st', 'nd', 'rd'];
                                const v = n % 100;
                                const suffix = (v >= 11 && v <= 13) ? 'th' : (s[v % 10] || 'th');
                                return n + suffix;
                              })() : '-----'}
                            </td>
                            <td>{transaction?.userTotalRecharges != null ? transaction.userTotalRecharges : '-----'}</td>
                            <td>₹{Number(transaction?.paidAmount || 0).toFixed(2)}</td>
                            <td>
                              <span style={{ 
                                color: transaction?.status === 'COMPLETED' ? 'green' : transaction?.status === 'FAILED' ? 'red' : 'gray',
                                fontWeight: 'bold'
                              }}>
                                {transaction?.status}
                              </span>
                            </td>
                            <td>{transaction?.coins || "---"}</td>
                            <td style={{ textTransform: 'capitalize' }}>{transaction?.platform || "---"}</td>
                            <td>{transaction?.paymentMethod || "---"}</td>
                            <td>
                              <span style={{ 
                                color: transaction?.supportStatus === 'resolved' ? 'green' : 
                                       transaction?.supportStatus === 'marked' ? 'orange' : 'gray',
                                fontWeight: 'bold'
                              }}>
                                {transaction?.supportStatus || 'Pending'}
                              </span>
                            </td>
                            <td>
                              {transaction?.supportRemarks ? 
                                <span title={transaction.supportRemarks} style={{ 
                                  display: 'block',
                                  maxWidth: '150px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}>
                                  {transaction.supportRemarks}
                                </span> : 
                                '---'
                              }
                            </td>
                            <td>
                              {
                                transaction?.status != 'COMPLETED' && (
                              
                              <IconButton 
                                size="small" 
                                onClick={() => handleSupportStatusClick(transaction)}
                                style={{ color: '#FF8989' }}
                                title="Update Support Status"
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                                )}
                            </td>
                          </tr>
                        </React.Fragment>
                      ))
                    ) : (
                      <NotFound
                        cols={15}
                        msg="Recharge transactions not found!"
                        icon={NOT_FOUND}
                        loader={loader}
                      />
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="pagination-wrapper mt-4 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-3">
                  <Typography variant="body2" color="textSecondary">
                    Show:
                  </Typography>
                  <select
                    value={rechargePageSize}
                    onChange={(e) => setRechargePageSize(parseInt(e.target.value))}
                    style={{ 
                      padding: '8px 12px', 
                      border: '1px solid #ccc', 
                      borderRadius: '4px',
                      fontSize: '14px',
                      minWidth: '80px'
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                  <Typography variant="body2" color="textSecondary">
                     per page
                  </Typography>
                </div>
                
                <div className="d-flex align-items-center gap-2">
                  <Typography variant="body2" color="textSecondary">
                    Showing {((activePage - 1) * rechargePageSize) + 1} to {Math.min(activePage * rechargePageSize, rechargeTotal)} of {rechargeTotal} items
                  </Typography>
                </div>
                
                {rechargeTotal > rechargePageSize && (
                  <div className="Pagination">
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={rechargePageSize}
                      totalItemsCount={rechargeTotal}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                )}
              </div>
            </>
          )}

          {/* Spending History Tab */}
          {activeTab === 1 && (
            <>
              {/* Indicator Tabs - hidden by default, show on tap */}
              <div className="indicator-tabs" style={{ marginBottom: '20px' }}>
                {!showSpendingIndicators ? (
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={() => setShowSpendingIndicators(true)}
                    onKeyDown={(e) => e.key === 'Enter' && setShowSpendingIndicators(true)}
                    style={{
                      padding: '10px 16px',
                      background: '#f0f0f0',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: '#666',
                      userSelect: 'none'
                    }}
                  >
                    Tap to show summary (No. of Transactions, Total Coin Spending)
                  </div>
                ) : (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {spendingTotalTransaction}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>No. of Transactions</div>
                    </div>
                    <div className="indicator-item" style={{ 
                      background: '#f0f0f0', 
                      padding: '10px 20px', 
                      borderRadius: '8px',
                      textAlign: 'center'
                    }}>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FF8989' }}>
                        {spendingTotalAmount.toFixed(2)}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>Total Coin Spending</div>
                    </div>
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => setShowSpendingIndicators(false)}
                      onKeyDown={(e) => e.key === 'Enter' && setShowSpendingIndicators(false)}
                      style={{
                        padding: '10px 16px',
                        alignSelf: 'center',
                        cursor: 'pointer',
                        fontSize: '12px',
                        color: '#666',
                        textDecoration: 'underline',
                        userSelect: 'none'
                      }}
                    >
                      Hide summary
                    </div>
                  </div>
                )}
              </div>

              {/* Filters */}
              <div className="FilterBox FilterArea" style={{ flexDirection: 'column' }}>
                {/* Row 1: Search Bar and Basic Filters */}
                <div className="group_filter_value" style={{ 
                  marginBottom: '15px', 
                  display: 'flex !important', 
                  flexWrap: 'wrap !important', 
                  gap: '15px', 
                  alignItems: 'center',
                  width: '100%',
                  flexDirection: 'row'
                }}>
                  {/* Search Bar */}
                  <div className="form-group search_md_size userSearch" style={{ minWidth: '200px', flex: '1 1 auto' }}>
                    <input
                      type="search"
                      className={`form-control ${spendingSearch && "active"}`}
                      placeholder="Search by User Name, User ID, Consultant Name"
                      value={spendingSearch || ""}
                      style={{ "--color": "#FF8989" }}
                      onChange={(e) => setSpendingSearch(e.target.value)}
                    />
                  </div>

                  {/* Time Range Filter */}
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>Time Range</InputLabel>
                      <Select
                        value={timeRange}
                        onChange={(e) => handleTimeRangeChange(e.target.value)}
                        label="Time Range"
                      >
                        <MenuItem value="">
                          <em>All Time Ranges</em>
                        </MenuItem>
                        {timeRangeOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  
                  {timeRange === 'custom' && (
                    <>
                      <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                        <TextField
                          size="small"
                          type="date"
                          variant="outlined"
                          label="Start Date"
                          value={timeRangeStartDate}
                          onChange={(e) => handleTimeRangeDateChange('start', e.target.value)}
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                      <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                        <TextField
                          size="small"
                          type="date"
                          variant="outlined"
                          label="End Date"
                          value={timeRangeEndDate}
                          onChange={(e) => handleTimeRangeDateChange('end', e.target.value)}
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                    </>
                  )}

                  {/* Session Type */}
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>Session Type</InputLabel>
                      <Select
                        value={spendingSessionTypeFilter}
                        onChange={(e) => setSpendingSessionTypeFilter(e.target.value)}
                        label="Session Type"
                      >
                        <MenuItem value="">
                          <em>All Types</em>
                        </MenuItem>
                        <MenuItem value="private_call">Consult</MenuItem>
                        <MenuItem value="session">Fixed Session</MenuItem>
                        <MenuItem value="session_book">Book Session</MenuItem>
                        <MenuItem value="gifts">Gifts</MenuItem>
                        <MenuItem value="meditation">Meditation</MenuItem>
                        <MenuItem value="vastu">Vastu</MenuItem>
                        <MenuItem value="refund">Refund</MenuItem>
                        <MenuItem value="wallet_refund">Wallet Refund</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  {/* Mode of Consultation */}
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>Mode</InputLabel>
                      <Select
                        value={spendingModeFilter}
                        onChange={(e) => setSpendingModeFilter(e.target.value)}
                        label="Mode"
                      >
                        <MenuItem value="">
                          <em>All Modes</em>
                        </MenuItem>
                        <MenuItem value="chat">Chat</MenuItem>
                        <MenuItem value="audio">Call</MenuItem>
                        <MenuItem value="video">Video Call</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
    
                  {/* Problem Filter */}
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>Problem</InputLabel>
                      <Select
                        value={spendingProblemFilter}
                        onChange={(e) => setSpendingProblemFilter(e.target.value)}
                        label="Problem"
                      >
                        <MenuItem value="">
                          <em>All Problems</em>
                        </MenuItem>
                        {problemOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  {/* User Spend # Filter */}
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>User Spend #</InputLabel>
                      <Select
                        value={spendingUserSpendFilter}
                        onChange={(e) => setSpendingUserSpendFilter(e.target.value)}
                        label="User Spend #"
                      >
                        <MenuItem value="">
                          <em>All</em>
                        </MenuItem>
                        <MenuItem value="1">1</MenuItem>
                        <MenuItem value="2">2</MenuItem>
                        <MenuItem value="3">3</MenuItem>
                        <MenuItem value="repeat">Repeat</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  {/* User Total Spends Filter */}
                  <div className="form-group select_sm_width" style={{ minWidth: '150px', flex: '0 0 auto' }}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>User Total Spends</InputLabel>
                      <Select
                        value={spendingUserTotalSpendsFilter}
                        onChange={(e) => setSpendingUserTotalSpendsFilter(e.target.value)}
                        label="User Total Spends"
                      >
                        <MenuItem value="">
                          <em>All</em>
                        </MenuItem>
                        {userTotalSpendsOptions.map((value) => (
                          <MenuItem key={value} value={String(value)}>
                            {value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  {/* Apply Filter & Clear */}
                  <div className="form-group refresh_button" style={{ minWidth: '120px', flex: '0 0 auto', display: 'flex', gap: '10px' }}>
                    <SecondaryButton onClick={() => fetchSpendingList()}>
                      Apply
                    </SecondaryButton>
                    <SecondaryButton onClick={clearSpendingFilters}>
                      Clear
                    </SecondaryButton>
                    <SecondaryButton 
                      onClick={downloadSpendingCSV}
                      disabled={csvLoading}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '8px 16px',
                        fontSize: '14px',
                        fontWeight: '500'
                      }}
                    >
                      {csvLoading ? (
                        <span>Downloading...</span>
                      ) : (
                        <>
                          <FileDownloadIcon style={{ fontSize: '16px' }} />
                          Export CSV
                        </>
                      )}
                    </SecondaryButton>
                  </div>

                 
                </div>
              </div>

              {/* Spending History Table */}
              <div className="content-table">
                <table>
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>User ID</th>
                      <th>User Name</th>
                      <th>User Spend </th>
                      <th>User Total Spends</th>
                      <th>Session Type</th>
                      <th>Date & Time</th>
                      <th>Consult By</th>
                      <th>Mode of Consultation</th>
                      <th>Problem</th>
                      <th>Coin Spent</th>
                      <th>Duration</th>
                      <th>Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {spendingList.length > 0 ? (
                      spendingList.map((transaction, index) => (
                        <React.Fragment key={transaction._id || "---"}>
                          <tr>
                            <td>{findSerialNumber(index, activePage, spendingPageSize) || "---"}</td>
                            <td>{transaction?.userDetails?.userId || "---"}</td>
                            <td>
                              <Link to={`/user/user-detail/${transaction?.userDetails?._id}`}>
                                {charLimit(transaction?.userDetails?.name, 30) || "---"}
                              </Link>
                          </td>
                            <td title={transaction?.userSpendNumber != null ? `This is this user's ${transaction.userSpendNumber} spend (total ${transaction?.userTotalSpends ?? '—'} spends)` : undefined}>
                              {transaction?.userSpendNumber != null ? (() => {
                                const n = Number(transaction.userSpendNumber);
                                if (Number.isNaN(n)) return '-----';
                                if (n > 3) return 'Repeat';
                                const s = ['th', 'st', 'nd', 'rd'];
                                const v = n % 100;
                                const suffix = (v >= 11 && v <= 13) ? 'th' : (s[v % 10] || 'th');
                                return n + suffix;
                              })() : '-----'}
                            </td>
                            <td>{transaction?.userTotalSpends != null ? transaction.userTotalSpends : '-----'}</td>
                            <td>{transaction?.sessionType  == 'private_call' ? 'Consult' : transaction?.sessionType  == 'session' ? 'Fixed Session' : transaction?.sessionType  == 'gifts' ? 'Gifts' : transaction?.sessionType  == 'meditation' ? 'Meditation' : transaction?.sessionType  == 'vastu' ? 'Vastu' : transaction?.sessionType  == 'session_book' ? 'Book Session' : transaction?.sessionType  == 'refund' ? 'Refund' : transaction?.sessionType  == 'wallet_refund' ? 'Wallet Refund' : "---"}</td>
                          <td>{dateFormatWithTime(transaction?.createdAt) || "---"}</td>
                          <td>
                            {
                              transaction?.consultantDetails?.length > 0 ? (
                                <Link to={`/consultant-management/consultant-detail/${transaction?.consultantDetails[0]?._id}`}>
                                  {charLimit(transaction?.consultantDetails[0]?.accountName, 30) || "---"}
                                </Link>
                              ) : (
                                "---"
                              )
                            }
                              
                          </td>
                            <td>{transaction?.mode  == 'audio' ? 'Call' : transaction?.mode  == 'video' ? 'Video Call' : transaction?.mode  == 'chat' ? 'Chat' : "---"}</td>
                            <td>{transaction?.problem || "---"}</td>
                            <td>{
                            transaction?.sessionType  == 'session' ? transaction?.waitlistDetails[0]?.onCompletion?.amountToDeduct.toFixed(2)   : transaction?.coins.toFixed(2) || "0"}</td>
                            <td>{
                              transaction?.waitlistDetails?.length > 0 ? (
                                <span>
                                  {formatDuration(transaction?.waitlistDetails[0]?.onCompletion?.callDurationInSeconds)} min
                                </span>
                              ) : (
                                "---"
                              )
                            }</td>
                            <td>{transaction?.rate || "---"}</td>
                        </tr>
                      </React.Fragment>
                      ))
                ) : (
                  <NotFound
                        cols={13}
                        msg="Spending transactions not found!"
                    icon={NOT_FOUND}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>

              {/* Pagination */}
              <div className="pagination-wrapper mt-4 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-3">
                  <Typography variant="body2" color="textSecondary">
                    Show:
                  </Typography>
                  <select
                    value={spendingPageSize}
                    onChange={(e) => setSpendingPageSize(parseInt(e.target.value))}
                    style={{ 
                      padding: '8px 12px', 
                      border: '1px solid #ccc', 
                      borderRadius: '4px',
                      fontSize: '14px',
                      minWidth: '80px'
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                  <Typography variant="body2" color="textSecondary">
                     per page
                  </Typography>
                </div>
                
                <div className="d-flex align-items-center gap-2">
                  <Typography variant="body2" color="textSecondary">
                    Showing {((activePage - 1) * spendingPageSize) + 1} to {Math.min(activePage * spendingPageSize, spendingTotal)} of {spendingTotal} items
                  </Typography>
                </div>
                
                {spendingTotal > spendingPageSize && (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                      itemsCountPerPage={spendingPageSize}
                      totalItemsCount={spendingTotal}
                      pageRangeDisplayed={5}
                  onChange={handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                />
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Support Status Modal */}
      <Dialog 
        open={supportStatusModal} 
        onClose={closeModel}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Update Support Status</DialogTitle>
        <DialogContent>
          <div style={{ padding: '20px 0', display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {/* Transaction Details */}
            <div style={{ 
              background: '#f5f5f5', 
              padding: '15px', 
              borderRadius: '8px',
              border: '1px solid #ddd'
            }}>
              <h4 style={{ margin: '0 0 10px 0', color: '#333' }}>Transaction Details</h4>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', fontSize: '14px' }}>
                <div><strong>Order ID:</strong> {selectedTransaction?.orderId || '---'}</div>
                <div><strong>Amount:</strong> ₹{selectedTransaction?.paidAmount || 0}</div>
                <div><strong>User:</strong> {selectedTransaction?.userDetails?.name || '---'}</div>
                <div><strong>Status:</strong> {selectedTransaction?.status || '---'}</div>
              </div>
            </div>

            {/* Support Status */}
            <FormControl fullWidth>
              <InputLabel>Support Status</InputLabel>
              <Select
                value={supportStatus}
                onChange={(e) => setSupportStatus(e.target.value)}
                label="Support Status"
              >
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="marked">Marked</MenuItem>
                <MenuItem value="resolved">Resolved</MenuItem>
              </Select>
            </FormControl>

            {/* Failure Type */}
            <FormControl fullWidth>
              <InputLabel>Failure Type</InputLabel>
              <Select
                value={failureType}
                onChange={(e) => setFailureType(e.target.value)}
                label="Failure Type"
                disabled={supportStatus === 'resolved'}
              >
                <MenuItem value="">Select Failure Type</MenuItem>
                <MenuItem value="payment_gateway">Payment Gateway Error</MenuItem>
                <MenuItem value="insufficient_funds">Insufficient Funds</MenuItem>
                <MenuItem value="user_cancelled">User Cancelled</MenuItem>
                <MenuItem value="technical_error">Technical Error</MenuItem>
                <MenuItem value="fraud_detected">Fraud Detected</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
            </FormControl>

            {/* Support Remarks */}
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Support Remarks"
              value={supportRemarks}
              onChange={(e) => setSupportRemarks(e.target.value)}
              placeholder="Enter remarks about the transaction failure..."
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModel} color="secondary">
            Cancel
          </Button>
          <Button 
            onClick={handleSupportStatusUpdate} 
            variant="contained"
            style={{ backgroundColor: '#FF8989', color: 'white' }}
          >
            Update Status
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TransactionManagement;
